import React from 'react';

function Page4SubPageB1() {
    return <h1>Popular</h1>;
}

export default Page4SubPageB1;